import { SagaIterator } from 'redux-saga';
import { put, call, takeLatest, StrictEffect, select } from 'redux-saga/effects';

import {
  fetchSiteListError,
  fetchSiteList,
  fetchSiteListSuccess,
  addSiteList,
  removeSiteList,
  removeSiteSuccess,
  addSiteListSuccess,
  ISiteListData,
  SiteName,
  getLastWebsiteAudit,
  getLastWebsiteAuditSuccess,
  getLastWebsiteAuditError,
  addSiteLisError,
  fetchCompanySiteList,
  fetchCompanySiteListSuccess,
  fetchCompanySiteListError,
  _updateAdSiteList,
} from './index';
import { apiInstance } from 'src/services/interceptor';
import { PayloadAction } from '@reduxjs/toolkit';
import { fetchSitesDetails } from '../sitesDetails';

function* getSiteList(): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    const response = yield call(apiInstance, `reporttool/site/${user.tenantId}`);
    // const response = yield call(apiInstance, `tenant/${user.tenantId}/sites`);
    const siteIds = response.data.map((e: ISiteListData) => e.siteId);

    const siteResponse = yield call(apiInstance, `reporttool/site/${user.tenantId}`, {
      params: { siteIds: siteIds.join(',') },
    });

    const newData = response.data.map((e: ISiteListData) => {
      const additionalInfo = siteResponse.data.filter((el: any) => `${e.siteId}` === el.site_id)[0];

      return additionalInfo
        ? Object.assign({}, e, {
            compliance_score: additionalInfo.compliance_score,
            reporter_last_run: additionalInfo.reporter_last_run,
            reporter_is_running: additionalInfo.reporter_is_running,
            site_number_of_pages: additionalInfo.site_number_of_pages,
            compliance_status: additionalInfo.compliance_status,
          })
        : e;
    });
    yield put(fetchSiteListSuccess(newData));
  } catch (e) {
    yield put(fetchSiteListError('error'));
  }
}

function* addSite({ payload }: PayloadAction<any>): SagaIterator {
  try {
    yield put(_updateAdSiteList());
    if (payload?.submitCallback) {
      
      const response = yield call(apiInstance.post, payload.isAccountPage ? `reporttool/usermanagement/website/add-website-to-company`: 'reporttool/usermanagement/website/member-adds-website-to-company',{
                    websiteUrl: payload.values.websiteUrl,
                    company_id: payload.companyId
                  });
      if ( response?.data?.data?.site_id ) {
        yield put(addSiteListSuccess(
       {   
          label: response?.data?.data?.site_name,
          value: response?.data?.data?.id,
          company_id: response?.data?.data?.company_id
        }
        ));
        payload?.submitCallback();
        return
      }
 
      const alertMessage = response?.data?.message ?? `Enable to Add ${payload.values.websiteUrl}. Please Try Again Later.`
      payload?.errorCallback?.(alertMessage)
      yield put(addSiteLisError('Something went wrong while saving site'));
    } else {
      const response = yield call(apiInstance.post, payload.isAccountPage ? `reporttool/usermanagement/website/add-website-to-company`: 'reporttool/usermanagement/website/member-adds-website-to-company', { 
        websiteUrl: payload.values.websiteUrl,
        company_id: payload.companyId
      });      
      if ( response?.data?.data.site_id ) {
        yield put(addSiteListSuccess(
          {   
            label: response?.data?.data?.site_name,
            value: response?.data?.data?.id,
            company_id: response?.data?.data?.company_id
          }
        ));
        yield put(fetchSitesDetails());
        return
      }
      const alertMessage = response?.data?.message ?? `Enable to Add ${payload.values.websiteUrl}. Please Try Again Later.`
      payload?.errorCallback?.(alertMessage)
      yield put(addSiteLisError('Somthing went wrong while saving site'));
    }
  } catch (e : any) {
    const error =  e?.response?.data?.message ?? "error";
    payload?.errorCallback?.(`Enable to Add ${payload.values.websiteUrl}. Please Try Again Later  `)
    yield put(addSiteLisError(error));
    // yield put(fetchSiteListError(error));
  }
}

function* removeSite({ payload }:any): SagaIterator {
  try {
    
    const response = yield call(apiInstance.delete, `reporttool/usermanagement/website/delete-website-from-company`,{
      data: {
        siteUUID:payload.siteUUID
      }
    });
    if (response?.status == 200 && response?.data) {
      payload?.submitCallback?.()
      yield put(removeSiteSuccess());
      if (payload.companyId) {
        yield call(fetchCompanySiteListSaga, { payload: { currentCompanyId: payload.companyId, isAccountPage: payload.isAccountPage } });
      }
      return
    }
    payload?.errorCallback?.(`Enable to Delete Site. Please Try Again Later.`)
  } catch (e) {
    payload?.errorCallback?.(`Enable to Delete Site. Please Try Again Later.`)
    yield put(fetchSiteListError("error deleting site"));
  }
}

function* getLastAuditSiteSaga({ payload }: PayloadAction<string>): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    const response = yield call(apiInstance.post, `reporttool/organisationlevel/sites/last-website-run` , {  company_id : user?.company_id });
    
    
    if ( response && response.status == 200 ){
      yield put(getLastWebsiteAuditSuccess(response));

      return
    }
    yield put(getLastWebsiteAuditError('error'));

  } catch (e:any) {
    const errorMessage = e?.response?.data?.message ?? "error"
    yield put(getLastWebsiteAuditError(errorMessage));
  }
}


function* fetchCompanySiteListSaga({payload}: any): SagaIterator {
  try {
    let response = null;    


    if(payload?.isLatest){
      response = yield call(apiInstance.post, `reporttool/usermanagement/website/get-all-websites`);
    }
    else if(payload.isAccountPage){
       response = yield call(apiInstance.post, `reporttool/usermanagement/website/get-own-company-websites`,{company_id:payload.currentCompanyId});
    }
    else{
       response = yield call(apiInstance.post, `reporttool/usermanagement/website/get-member-company-websites`,{company_id:payload.currentCompanyId});
    }    
    if(response.data.data.message){
      yield put(fetchSiteListSuccess({result:[],id:payload.currentCompanyId ?? 'Latest'}));
      yield put(fetchSiteListError(response.data.data.message))
      return;
    }
    if(response?.data?.data){
      payload?.submitCallback?.(response?.data?.data)
      yield put(fetchSiteListSuccess({result:response.data.data,id:payload.currentCompanyId ?? 'Latest'}));
      return;
    }
    if ( response?.data?.message ) {
      payload?.submitCallback?.([])
      yield put(fetchSiteListSuccess({result:[],id:payload.currentCompanyId ?? 'Latest'}));
      return;
    }
    payload?.errorCallback?.(`Enable to get websites.`)
    yield put(fetchSiteListError('error'))
  } catch (e) {
    payload?.errorCallback?.(`Enable to get websites.`)
    yield put(fetchSiteListError('error'));
  }
}


function* siteListSaga(): Generator<StrictEffect, void> {
  yield takeLatest(fetchSiteList.type, fetchCompanySiteListSaga);
  yield takeLatest(addSiteList.type, addSite);
  yield takeLatest(removeSiteList.type, removeSite);
  yield takeLatest(removeSiteSuccess.type, fetchCompanySiteListSaga);
  yield takeLatest(addSiteListSuccess.type, fetchCompanySiteListSaga);
  yield takeLatest(getLastWebsiteAudit.type, getLastAuditSiteSaga);
  // yield takeLatest(fetchCompanySiteList.type, fetchCompanySiteListSaga);
}

export { siteListSaga };
